import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import './i18n';  // Import i18n configuration
import { FeedUpdater } from './utils/feedUpdater';
import { initializeAnalytics, initializeAds } from './utils/analytics';

// Initialize Google services
initializeAnalytics(import.meta.env.VITE_GA_MEASUREMENT_ID);
initializeAds(import.meta.env.VITE_ADSENSE_CLIENT_ID);

// Initialize feed service
FeedUpdater.getInstance().start().catch(console.error);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);